import { chooseBestImage } from '../../../common/resizer';
import LogoBrickABrackAvif from './assets/BrickABrack.jpg?as=avif&width=64';
import LogoBrickABrack from './assets/BrickABrack.jpg?as=jpg&width=64';
import LogoBrickABrackWebp from './assets/BrickABrack.jpg?as=webp&width=64';
import LogoBrickBoardAvif from './assets/BrickBoard.png?as=avif&width=64';
import LogoBrickBoard from './assets/BrickBoard.png?as=jpg&width=64';
import LogoBrickBoardWebp from './assets/BrickBoard.png?as=webp&width=64';
import LogoBrickCinemaAvif from './assets/BrickCinema.png?as=avif&width=64';
import LogoBrickCinema from './assets/BrickCinema.png?as=jpg&width=64';
import LogoBrickCinemaWebp from './assets/BrickCinema.png?as=webp&width=64';
import LogoBrickFestAvif from './assets/BrickFest.png?as=avif&width=64';
import LogoBrickFest from './assets/BrickFest.png?as=jpg&width=64';
import LogoBrickFestWebp from './assets/BrickFest.png?as=webp&width=64';
import LogoBrickfilmDayAvif from './assets/BrickfilmDay.png?as=avif&width=64';
import LogoBrickfilmDay from './assets/BrickfilmDay.png?as=jpg&width=64';
import LogoBrickfilmDayWebp from './assets/BrickfilmDay.png?as=webp&width=64';
import LogoBrickfilmersGuildAvif from './assets/BrickfilmersGuild.png?as=avif&width=64';
import LogoBrickfilmersGuild from './assets/BrickfilmersGuild.png?as=jpg&width=64';
import LogoBrickfilmersGuildWebp from './assets/BrickfilmersGuild.png?as=webp&width=64';
import LogoBrickfilmsAvif from './assets/Brickfilms.jpg?as=avif&width=64';
import LogoBrickfilms from './assets/Brickfilms.jpg?as=jpg&width=64';
import LogoBrickfilmsWebp from './assets/Brickfilms.jpg?as=webp&width=64';
import LogoBrickFlicksAvif from './assets/BrickFlicks.png?as=avif&width=64';
import LogoBrickFlicks from './assets/BrickFlicks.png?as=jpg&width=64';
import LogoBrickFlicksWebp from './assets/BrickFlicks.png?as=webp&width=64';
import LogoBricksByTheBayAvif from './assets/BricksByTheBay.png?as=avif&width=64';
import LogoBricksByTheBay from './assets/BricksByTheBay.png?as=jpg&width=64';
import LogoBricksByTheBayWebp from './assets/BricksByTheBay.png?as=webp&width=64';
import LogoBricksInMotionAvif from './assets/BricksInMotion.png?as=avif&width=64';
import LogoBricksInMotion from './assets/BricksInMotion.png?as=jpg&width=64';
import LogoBricksInMotionWebp from './assets/BricksInMotion.png?as=webp&width=64';
import LogoBrickVideoStudioAvif from './assets/BrickVideoStudio.png?as=avif&width=64';
import LogoBrickVideoStudio from './assets/BrickVideoStudio.png?as=jpg&width=64';
import LogoBrickVideoStudioWebp from './assets/BrickVideoStudio.png?as=webp&width=64';
import LogoBrickWorldFilmFestivalAvif from './assets/BrickWorldFilmFestival.png?as=avif&width=64';
import LogoBrickWorldFilmFestival from './assets/BrickWorldFilmFestival.png?as=jpg&width=64';
import LogoBrickWorldFilmFestivalWebp from './assets/BrickWorldFilmFestival.png?as=webp&width=64';
import LogoCineBrickAvif from './assets/CineBrick.png?as=avif&width=64';
import LogoCineBrick from './assets/CineBrick.png?as=jpg&width=64';
import LogoCineBrickWebp from './assets/CineBrick.png?as=webp&width=64';
import LogoCineBriqueVFAvif from './assets/CineBriqueVF.png?as=avif&width=64';
import LogoCineBriqueVF from './assets/CineBriqueVF.png?as=jpg&width=64';
import LogoCineBriqueVFWebp from './assets/CineBriqueVF.png?as=webp&width=64';
import LogoCineBriqueVQAvif from './assets/CineBriqueVQ.png?as=avif&width=64';
import LogoCineBriqueVQ from './assets/CineBriqueVQ.png?as=jpg&width=64';
import LogoCineBriqueVQWebp from './assets/CineBriqueVQ.png?as=webp&width=64';
import LogoKlugAvif from './assets/Klug.png?as=avif&width=64';
import LogoKlug from './assets/Klug.png?as=jpg&width=64';
import LogoKlugWebp from './assets/Klug.png?as=webp&width=64';
import LogoLegoAvif from './assets/Lego.png?as=avif&width=64';
import LogoLego from './assets/Lego.png?as=jpg&width=64';
import LogoLegoWebp from './assets/Lego.png?as=webp&width=64';
import LogoNWBrickConAvif from './assets/NWBrickCon.png?as=avif&width=64';
import LogoNWBrickCon from './assets/NWBrickCon.png?as=jpg&width=64';
import LogoNWBrickConWebp from './assets/NWBrickCon.png?as=webp&width=64';
import LogoPalikkatakomoAvif from './assets/Palikkatakomo.jpg?as=avif&width=64';
import LogoPalikkatakomo from './assets/Palikkatakomo.jpg?as=jpg&width=64';
import LogoPalikkatakomoWebp from './assets/Palikkatakomo.jpg?as=webp&width=64';
import LogoTheBrickFlixFestivalAvif from './assets/TheBrickFlixFestival.png?as=avif&width=64';
import LogoTheBrickFlixFestival from './assets/TheBrickFlixFestival.png?as=jpg&width=64';
import LogoTheBrickFlixFestivalWebp from './assets/TheBrickFlixFestival.png?as=webp&width=64';
import LogoWmbfAvif from './assets/Wmbf.png?as=avif&width=64';
import LogoWmbf from './assets/Wmbf.png?as=jpg&width=64';
import LogoWmbfWebp from './assets/Wmbf.png?as=webp&width=64';

const icons = {
    BrickABrack: chooseBestImage([LogoBrickABrack, LogoBrickABrackWebp, LogoBrickABrackAvif]),
    BrickBoard: chooseBestImage([LogoBrickBoard, LogoBrickBoardWebp, LogoBrickBoardAvif]),
    BrickCinema: chooseBestImage([LogoBrickCinema, LogoBrickCinemaWebp, LogoBrickCinemaAvif]),
    BrickfilmDay: chooseBestImage([LogoBrickfilmDay, LogoBrickfilmDayWebp, LogoBrickfilmDayAvif]),
    BrickfilmersGuild: chooseBestImage([LogoBrickfilmersGuild, LogoBrickfilmersGuildWebp, LogoBrickfilmersGuildAvif]),
    Brickfilms: chooseBestImage([LogoBrickfilms, LogoBrickfilmsWebp, LogoBrickfilmsAvif]),
    BrickFlicks: chooseBestImage([LogoBrickFlicks, LogoBrickFlicksWebp, LogoBrickFlicksAvif]),
    BricksInMotion: chooseBestImage([LogoBricksInMotion, LogoBricksInMotionWebp, LogoBricksInMotionAvif]),
    BrickWorldFilmFestival: chooseBestImage([LogoBrickWorldFilmFestival, LogoBrickWorldFilmFestivalWebp, LogoBrickWorldFilmFestivalAvif]),
    CineBrick: chooseBestImage([LogoCineBrick, LogoCineBrickWebp, LogoCineBrickAvif]),
    Klug: chooseBestImage([LogoKlug, LogoKlugWebp, LogoKlugAvif]),
    Lego: chooseBestImage([LogoLego, LogoLegoWebp, LogoLegoAvif]),
    Wmbf: chooseBestImage([LogoWmbf, LogoWmbfWebp, LogoWmbfAvif]),
    BrickVideoStudio: chooseBestImage([LogoBrickVideoStudio, LogoBrickVideoStudioWebp, LogoBrickVideoStudioAvif]),
    BrickFest: chooseBestImage([LogoBrickFest, LogoBrickFestWebp, LogoBrickFestAvif]),
    BricksByTheBay: chooseBestImage([LogoBricksByTheBay, LogoBricksByTheBayWebp, LogoBricksByTheBayAvif]),
    Palikkatakomo: chooseBestImage([LogoPalikkatakomo, LogoPalikkatakomoWebp, LogoPalikkatakomoAvif]),
    NWBrickCon: chooseBestImage([LogoNWBrickCon, LogoNWBrickConWebp, LogoNWBrickConAvif]),
    CineBriqueVQ: chooseBestImage([LogoCineBriqueVQ, LogoCineBriqueVQWebp, LogoCineBriqueVQAvif]),
    CineBriqueVF: chooseBestImage([LogoCineBriqueVF, LogoCineBriqueVFWebp, LogoCineBriqueVFAvif]),
    TheBrickFlixFestival: chooseBestImage([LogoTheBrickFlixFestival, LogoTheBrickFlixFestivalWebp, LogoTheBrickFlixFestivalAvif]),
};

const CalendarWebsiteLogo = ({ id = null, ...rest }) => {
    if (!icons[id]) {
        return null;
    }
    return <img {...rest} src={icons[id]} loading="lazy" />
}

export default CalendarWebsiteLogo;
